export function formSortQuery(obj) {
  let querySort = "id%desc";
  if (
    obj &&
    obj.column &&
    obj.state &&
    obj.column !== "" &&
    obj.state !== "" &&
    obj.state != 0
  ) {
    querySort = `${obj.column}%${obj.state}`;
  }
  return querySort;
}
